<template>
  <div class="wrapper">
    <div class="box">
      <div class="bo_bottom">
        <h2><span @click="herfFile"><img src="../assets/jiantou.png" alt=""><span>返回歌曲列表：</span></span></h2>
        <div class="container" @click="hideSele()">
          <div>
            <div class="lie">
              <div class="top">
                <span>*</span>
                <span>歌曲名称</span>
                <span>（必填：不超过10个字）</span>
              </div>
              <div class="bottom">
                <input type="text" v-model="gq" placeholder="如：青花瓷">
              </div>
            </div>
            <div class="lie">
              <div class="top">
                <span>*</span>
                <span>演唱者</span>
                <span>（必填：不超过20个字，该信息不准确可能导致下架）</span>
              </div>
              <div class="bottom">
                <input type="text" v-model="singer" placeholder="如：周杰伦">
              </div>
            </div>
            <div class="lie bt_file">
              <div class="top">
                <span>*</span>
                <span>音乐文件</span>
                <span>（必填 :仅限MP3格式 , 不超过20M）</span>
              </div>
              <div class="bottom">
                <!-- <a href="#">选择文件<input type="file" value="http://upload.qiniup.com "></a> -->
                <el-upload ref="upload" class="upload-demo" action="https://up-as0.qiniup.com" :data="pppss" :auto-upload="false" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" :limit="1" accept='audio/mp3' :on-exceed="handleExceed" :before-upload="beforeUpload" :on-success="onSuccess" :file-list="fileList">
                  <button size="small" type="primary">点击上传</button>
                  <!-- <div slot="tip" class="el-upload__tip">只能上传mp3文件</div> -->
                </el-upload>
              </div>
            </div>
            <div class="lie bt_select">
              <div class="top">
                <span>*</span>
                <span>音乐类型</span>
                <span>（必填 :若为伴奏 , 请选择伴奏）</span>
              </div>
              <div class="bottom">
                <div class="bot_1" @click.stop="showSele()"><span>{{selec.text}}</span>
                  <img src="../assets/ttt.png" alt="">
                </div>
                <div class="bot_2" v-show="selectFlag">
                  <span v-for="item in seletType" :key="item.type" @click="seleActive(item)" @mouseover="selectStyle(item)" :class="item.type==selec.seleType?'active':''">{{item.name}}</span>
                </div>
              </div>
              <div class="agre">
                <input type="checkbox" name="vehicle" :checked="checked" v-model="checked" />
                <span>我已认真阅读并同意</span>
                <span @click="dialogs=!dialogs">《用户上传歌曲伴奏文件协议》</span>
              </div>
            </div>
            <!-- <div class="lie bt_file">
              </div> -->
            <div class="lie bt_from">
              <div class="bottom">
                <button @click.stop="updatedSinger()" :class="!checked?'active':''">确认上传</button>
                <img src="../assets/ttt.png" alt="" v-show="singerUrl">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog" v-show="dialogs">
      <div class="box">
        <div class="title">用户上传歌曲伴奏协议</div>
        <div class="text mt20">
          用户上传歌曲伴奏及歌词文件不得包含一下违规内容，如违规上传，已经发现将
          永久删除上传文件，切上传文件的用户将被严惩永久封禁，情节极度恶劣者就追
          究法律责任。
        </div>
        <div class="text mt20">违规内容：</div>
        <div class="text">
          1.反对宪法所确定的基本原则；<br>
          2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
          3.损害国家荣誉和利益的；<br>
          4.煽动民族仇恨、民族歧视、破坏民族团结的；<br>
          5.破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
          6.散布谣言，扰乱社会秩序，破坏社会稳定的；<br>
          7.散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
          8.侮辱或者诽谤他人，侵害他人合法权利的；<br>
          9.煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；<br>
          10.以非法民间组织名义活动的；<br>
          11.含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、<br>
          或其它道德上令人反感的内容；<br>
          12.含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或
          禁止的其他内容的
        </div>
      </div>
      <button @click="dialogs=!dialogs">确定</button>
      <img src="../assets/guanbi.png" alt="" @click="dialogs=!dialogs">
    </div>
  </div>
</template>

<script>
// import { Message } from 'element-ui';
import { setTimeout } from 'timers';
export default {
  name: 'fileSong',
  components: {},
  props: {},
  data() {
    return {
      multiple: '',
      fileList: [],
      fileItem: {},
      seletType: [
        { 'name': '原唱', 'type': 1 },
        { 'name': '伴唱', 'type': 2 },
      ],
      selectFlag: false,
      selec: {
        type: 1,
        seleType: 1,
        text: '原唱'
      },
      url: 'https://www.tiantianyuyin.com/',
      urlDev: 'http://beta.tiantianyuyin.com/',
      singer: '',
      gq: '',
      pppss: {
        token: '',
        key: "qinghua",
      },
      token: null,
      limen: 3,
      bateUrl: 'http://video.tiantianyuyin.com/',
      singerUrl: null,
      url: '',
      checked: true,
      dialogs: false
    }
  },
  watch: {
    checked(v, l) {
      console.log(v, l);
    }
  },
  computed: {},
  methods: {
    agrHerg() {
      // this.$router.push({ path: '/agreement' });
    },
    herfFile() {
      this.$router.push({ path: '/songList' });
    },
    hideSele() {
      // console.log(11111111,this.selec);
      this.selectFlag = false;
    },
    showSele() {
      console.log(2222, this.selec);
      this.selec.seleType = this.selec.type;
      this.selectFlag = true;
    },
    seleActive(e) {
      // console.log(e,'seleActive');
      this.selec.text = e.name;
      this.selec.type = e.type;
    },
    selectStyle(e) {
      // console.log(e,'selectStyle');
      this.selec.seleType = e.type;
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      // if (['video/mp4', 'video/ogg', 'video/flv','video/avi','video/wmv','video/rmvb'].indexOf(file.type) == -1) {
      //   this.$message.error('请上传正确的视频格式');
      //   return false;
      // }
      // return this.$confirm(`确定移除 ${ file.name }？`);
    },
    onSuccess(res) {
      // console.log(res,this.pppss);
      if (res) {
        if (res.key) {
          this.singerUrl = this.bateUrl + res.key
          this.singUpload();
        }
      }
    },
    beforeUpload(file) {
      console.log(this);

      if (['audio/mp3'].indexOf(file.type) == -1) {
        // console.log('请上传mp3格式文件！');
        this.$Message({
          message: '请上传mp3格式文件！',
          type: 'error'
        });
        this.$refs.upload.clearFiles();
        return false;
      } else {
        this.fileItem = file;
        this.pppss.key = (+new Date()) + file.name.slice(-4);
        // console.log(file,this.pppss);
      }

    },
    async getUpToken() {
      let that = this;
      let res = null;
      await this.$axios({
        method: 'post',
        url: that.url + 'sings/getUpToken',
        params: {
          uid: that.user.uid
        }
      }).then(result => {
        // console.log(result);
        if (result.code == 200) {
          this.token = result.data;
          this.pppss.token = result.data;
          // console.log(this.pppss);
        } else {
          setTimeout(() => {
            that.limen = that.limen--;
            if (that.limen < 1) {
              that.getUpToken();
            };
          }, 1000)
        }
      })
    },
    async updatedSinger() {
      if (!this.checked) {
        this.$Message({
          message: '请观看并同意协议！',
          type: 'error'
        });
        return
      }
      let that = this;
      this.$refs.upload.submit();
    },
    async singUpload() {
      let that = this;
      console.log(that);
      if (!this.singer) {
        this.$Message({
          message: '请填写歌手名称',
          type: 'error'
        });
      }
      if (!this.gq) {
        this.$Message({
          message: '请填写歌手名称',
          type: 'error'
        });
      }
      // console.log(that.fileItem);
      await this.$axios({
        method: 'post',
        url: that.url + 'sings/upload',
        params: {
          name: that.gq,
          size: that.fileItem.size,
          type: that.selec.type,
          uid: that.user.uid,
          url: that.singerUrl,
          singer: that.singer,
        }
      }).then(result => {
        // console.log(result ,'上传成功')
        that.fileItem = {};
        this.selec = {
          type: 1,
          seleType: 1,
          text: '原唱'
        };
        this.singer = '';
        this.singerUrl = '';
        this.gq = '';
        this.$Message({
          message: '上传成功',
          type: 'success'
        });
        this.$refs.upload.clearFiles();
        // res= result;
      }).catch(res => {
        // console.log(res);
        that.fileItem = {};
        this.selec = {
          type: 1,
          seleType: 1,
          text: '原唱'
        };
        this.singer = '';
        this.gq = '';
        this.singerUrl = '';
        this.$Message({
          message: '上传失败，网络不稳定',
          type: 'success'
        });
        this.$refs.upload.clearFiles();
      })
    }
  },
  created() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.url = this.$store.state.user.url
    this.getUpToken();
    console.log(window.width);

    // this.$Message({
    //       message: '上传成功',
    //       type: 'success'
    //     });
  },
  mounted: () => {

  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: rgba(247, 247, 247, 1);
  padding-bottom: 20px;
  .box {
    margin: 0 auto;
    width: 1000px;
    min-height: 936px;
    box-sizing: border-box;
    // padding-top: 20px;
    display: flex;
    flex-direction: column;
    background: rgba(247, 247, 247, 1);
    .bo_bottom {
      width: 100%;
      background: #fff;
      box-sizing: border-box;
      height: 936px;
      background: rgba(255, 255, 255, 1);
      margin-top: 20px;
      padding: 22px;
      h2 {
        font-size: 22px;
        padding: 5px 0 26px;
        display: flex;
        align-items: center;
        > span {
          font-size: 16px;
          font-family: PingFang-SC-Regular;
          font-weight: 400;
          color: rgba(163, 163, 163, 1);
          margin-left: 6px;
          cursor: pointer;
        }
      }
      .container {
        background: rgba(255, 255, 255, 1);
        position: relative;
        display: flex;
        align-items: center;
        height: 500px;
        > div {
          margin: 0 auto;
          min-width: 425px;
          min-height: 100%;
          .lie {
            margin-bottom: 20px;
            .top {
              display: flex;
              > span:nth-child(1) {
                font-size: 20px;
                font-family: PingFang-SC-Medium;
                font-weight: 500;
                color: rgba(254, 71, 86, 1);
                line-height: 40px;
                display: inline-block;
              }
              > span:nth-child(2) {
                font-size: 18px;
                font-family: PingFang-SC-Medium;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                line-height: 40px;
                padding-left: 14px;
              }
              > span:nth-child(3) {
                font-size: 14px;
                font-family: PingFang-SC-Regular;
                color: rgba(163, 163, 163, 1);
                line-height: 40px;
              }
            }
            .bottom {
              input {
                width: 245px;
                height: 35px;
                border: 2px solid rgba(206, 206, 206, 1);
                box-sizing: border-box;
                padding-left: 13px;
              }
              button {
                width: 135px;
                height: 37px;
                line-height: 37px;
                background: rgba(11, 208, 206, 1);
                border-radius: 4px;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                border: none;
                outline: none;
              }
              .active {
                background: #dfdfdf;
              }
            }
          }
          .bt_file {
            .bottom {
              .el-upload {
                color: #fe5764;
                > button:nth-child(1) {
                  width: 135px;
                  height: 37px;
                  line-height: 37px;
                  background: rgba(11, 208, 206, 1);
                  border-radius: 4px;
                  color: rgba(255, 255, 255, 1);
                  font-size: 14px;
                  border: none;
                  outline: none;
                  position: relative;
                  display: block;
                  text-decoration: none;
                  text-align: center;
                  cursor: pointer;
                }
              }
            }
          }
          .bt_select {
            .bottom {
              position: relative;
              .bot_1 {
                width: 135px;
                height: 37px;
                border: 1px solid rgba(206, 206, 206, 1);
                border-radius: 4px;
                display: flex;
                padding-left: 8px;
                box-sizing: border-box;
                align-items: center;
                justify-content: space-between;
                cursor: pointer;
                > span {
                  font-size: 14px;
                  font-family: PingFang-SC-Regular;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                }
                img {
                  width: 42px;
                  height: 36px;
                }
              }
              .bot_2 {
                position: absolute;
                // left: -36%;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.11);
                border-radius: 5px;
                width: 135px;
                display: flex;
                flex-direction: column;
                span {
                  height: 40px;
                  line-height: 40px;
                  padding-left: 9px;
                  box-sizing: border-box;
                  font-size: 14px;
                  font-family: PingFang-SC-Regular;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                }
                // span:hover{
                //   background:rgba(246,246,246,1);
                // }
                .active {
                  background: rgba(246, 246, 246, 1);
                }
              }
            }
            .agre {
              padding-left: 6px;
              padding-top: 22px;
              display: flex;
              white-space: nowrap;
              align-items: center;
              span:nth-child(2) {
                color: #333;
                font-size: 14px;
              }
              span:nth-child(3) {
                color: #fe5764;
                font-size: 14px;
                cursor: pointer;
              }
            }
          }
          .bt_from {
            margin-top: 52px;
            width: 100%;
            text-align: center;
            .bottom {
              position: relative;
              button {
                width: 161px;
                height: 37px;
                background: rgba(11, 208, 206, 1);
                border-radius: 4px;
              }
              img {
                position: absolute;
                right: -40px;
                top: 50%;
                transform: translateY(-50%);
                width: 140px;
                height: 16px;
              }
            }
          }
        }
      }
    }
  }
  .dialog {
    // display: none;
    width: 786px;
    height: 840px;
    background: rgba(255, 255, 255, 1);
    border: 4px solid rgba(215, 215, 215, 1);
    position: fixed;
    top: 50px;
    left: 50%;
    transform: translate(-50%);
    padding: 30px 40px;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 5px;
    .box {
      width: 100%;
      display: flex;
      flex-direction: column;
      background: rgba(255, 255, 255, 1);
      > div {
        width: 100%;
        font-size: 20px;
        color: #333333;
      }
      .title {
        font-size: 24px;
        text-align: center;
      }
      .text {
        line-height: 35px;
      }
      .mt20 {
        margin-top: 20px;
      }
    }
    button {
      width: 103px;
      height: 45px;
      background: rgba(11, 208, 206, 1);
      border-radius: 4px;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translate(-50%);
      border: none;
      user-select: none;
      outline: none;
      color: #fff;
      cursor: pointer;
    }
    img {
      position: absolute;
      top: 3px;
      right: 3px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
  // .dialog::-webkit-scrollbar{
  //   width: 1;
  // }
}
</style>



// WEBPACK FOOTER //
// src/views/fileSong.vue